<template>
  <of-dialog
    :title="formTitleProg"
    @onCancel="cancel"
    @onConfirm="confirm"
    :appendToBody="true"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content" class="el-dialog-div">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataFormProg"
        :rules="editFormRules"
      >
        <el-form-item label="标题：" prop="Title">
          <el-input
            placeholder="请输入标题"
            v-model="dataFormProg.Title"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="进展描述：" prop="Describe">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入进展描述"
            v-model="dataFormProg.Describe"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="进展时间：" prop="ActivityTime">
          <el-date-picker
            v-model="dataFormProg.ActivityTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="图片：" prop="ActivityImage">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onPicUpdate"
            :on-remove="OnPicRemove"
            :on-preview="onPicPreview"
            :on-exceed="onPicExceed"
            :limit="9"
            :file-list="pictureList"
            accept=".jpg"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">支持扩展名：.jpg</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img
              style="width: 80%; height: 70%; margin-left: 10%"
              :src="dialogImageUrl"
              alt
            />
          </el-dialog>
        </el-form-item>

        <el-form-item label="上传附件：" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "progressedit",
  props: {
    dataFormProg: {
      type: Object,
      default: null,
    },
    formTitleProg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        Title: { required: true, message: "标题不能为空", trigger: "blur" },
        Describe: {
          required: true,
          message: "进展描述不能为空",
          trigger: "blur",
        },
        ActivityTime: {
          required: true,
          message: "进展时间不能为空",
          trigger: "blur",
        },
      },
      isConfirm: false,
      dialogImageUrl: "",
      dialogVisible: false,
      pictureList: [], //图片数组
      fileList: [], //附件数组

      width: "60%",
    };
  },
  components: {
    OfDialog,
    OfUpload,
  },
  mounted() {
    let that = this;
    that.getImg();
    that.getfile();
  },

  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataFormProg);
          params.ActivityTime = params.ActivityTime / 1000;
          api.AddScheduleImplementSchedule(params).then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$emit("formCallBack", params);
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          });
        }
      });
    },
    //初始化图片
    getImg() {
      let that = this;
      if (
        that.dataFormProg.ActivityImage ||
        that.dataFormProg.ActivityImage != null
      ) {
        let params = { Id: that.dataFormProg.ActivityImage };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataFormProg.File || that.dataFormProg.File != null) {
        let params = { Id: that.dataFormProg.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataFormProg.File && !that.dataFormProg.File) {
          that.dataFormProg.File = rtnResult.Data.FileId;
        } else {
          that.dataFormProg.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataFormProg.File = "";
      fileList.forEach((item) => {
        if (that.dataFormProg.File == "") {
          that.dataFormProg.File = item.response.Data.FileId;
        } else {
          that.dataFormProg.File += "," + item.response.Data.FileId;
        }
      });
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
    //图片上传
    onPicUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (
          !that.dataFormProg.ActivityImage &&
          !that.dataFormProg.ActivityImage
        ) {
          that.dataFormProg.ActivityImage = rtnResult.Data.FileId;
        } else {
          that.dataFormProg.ActivityImage += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //删除
    OnPicRemove(file, fileList) {
      let that = this;
      that.dataFormProg.ActivityImage = "";
      fileList.forEach((item) => {
        if (that.dataFormProg.ActivityImage == "") {
          that.dataFormProg.ActivityImage = item.response.Data.FileId;
        } else {
          that.dataFormProg.ActivityImage += "," + item.response.Data.FileId;
        }
      });
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl =
        "/api/File/Download?Id=" + file.response.Data.FileId;
      that.dialogVisible = true;
    },
    //上传限制
    onPicExceed() {
      let that = this;
      that.$message({
        message: "图片最多只能上传9张",
        type: "error",
      });
    },
  },
};
</script>
<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>
